import React from 'react';
import ReactDOM from 'react-dom/client';
import CacheBuster from 'react-cache-buster';
import packageInfo from '../package.json';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import Main from './Main.js';
import Recipe from './Recipe.js';
import Recipes from './Recipes.js';
import Page404 from './Page404.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <CacheBuster currentVersion={packageInfo.version} isEnabled={true} isVerboseMode={false}>
        <BrowserRouter>
            <Routes>
                <Route path="/recipe" element={<Recipe />}/>
                <Route path="/recipes" element={<Recipes />}/>
                <Route path="/" element={<Main />}/>
                <Route path="*" element={<Page404 />}/>
            </Routes>
        </BrowserRouter>
    </CacheBuster>
);
